import {Component, inject, OnInit} from '@angular/core';
import {IonButton, IonCol, IonInput, IonRow, IonSegment, IonSegmentButton} from '@ionic/angular/standalone';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {CommonService, Subscriber} from '../../../core/common.service';
import {LanguageService} from '../../../core/language.service';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-subscribe-banner',
  templateUrl: './subscribe-banner.component.html',
  styleUrls: ['./subscribe-banner.component.scss'],
  imports: [
    IonRow,
    IonCol,
    IonButton,
    IonInput,
    IonSegment,
    IonSegmentButton,
    ReactiveFormsModule,
    TranslateModule
  ]
})
export class SubscribeBannerComponent  implements OnInit {

  subscribeForm = new FormGroup({
    type: new FormControl('b2c'),
    email: new FormControl(null, [Validators.required, Validators.email]),
  });
  isSuccess: boolean = false;
  isError: boolean =false;
  message: string = '';
  isSaving: boolean = false;
  commonService: CommonService = inject(CommonService);
  languageService: LanguageService = inject(LanguageService);
  constructor() {
  }

  ngOnInit() {}


  isSubmit: boolean = false;
  async subscribe() {
    if (!this.subscribeForm.value.email) {
      this.isError = true;
      this.message = 'Enter email address';
      setTimeout(() => {
        this.isError = false;
        this.message = '';
      }, 3000);
      return;
    }
    if (this.isSubmit) {
      return;
    }
    this.isSubmit = true;
    this.isError = false;
    this.isSaving = true;
    try {
      const data: Subscriber = { email: this.subscribeForm.value.email, type: this.subscribeForm.value.type };
      const success = await this.commonService.saveUser(data);
      this.isSuccess = true;
      this.message = 'Thank you for subscribing';
      this.subscribeForm.reset({
        type: 'b2c'
      });
      this.isSaving = false;
      this.isSubmit = false;
    } catch (e) {
      this.isError = true;
      this.isSaving = false;
      this.isSubmit = false;
    }
    setTimeout(() => {
      this.isError = false;
      this.isSuccess = false;
    }, 3000);
  }


}
